import { render, staticRenderFns } from "./FiltroAdicionalBase.vue?vue&type=template&id=5e8d8473"
import script from "./FiltroAdicionalBase.vue?vue&type=script&lang=js"
export * from "./FiltroAdicionalBase.vue?vue&type=script&lang=js"
import style0 from "./FiltroAdicionalBase.vue?vue&type=style&index=0&id=5e8d8473&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports